import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const styles = () => ({
  root: {
    display: 'flex',
    '& button, & a': {
      borderRadius: '0',
    },
    '& button:first-child, & a:first-child': {
      borderRadius: '4px 0 0 4px',
    },
    '& button:last-child, & a:last-child': {
      borderRadius: '0 4px 4px 0',
    },
    '& button:not(:first-child), & a:not(:first-child)': {
      borderLeft: '0 !important',
    },
    '& button:first-child:last-child, & a:first-child:last-child': {
      borderRadius: 4,
    },
    'tr.disabled & button, tr.disabled & a': {
      marginLeft: 0,
    },
  },
})

const ButtonGroup = ({ children, classes, white }) => (
  <div className={cn(classes.root, white && classes.white, 'buttonGroup')}>{children}</div>
)

const ButtonGroupComponent = withStyles(styles)(ButtonGroup)
ButtonGroupComponent.displayName = 'ButtonGroup'
export default ButtonGroupComponent
